var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},_vm._l((_vm.data.attributes.content),function(block,index){return _c('lazy-' +
      block.__component.substring(block.__component.indexOf('.') + 1),{key:index,tag:"component",attrs:{"block":block,"breakBlockData":_vm.breakBlockData}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }